import type { Font } from '@/api/types/font-family'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@components/ui/select'
import { keepTextEditFocus } from '../handlers/keep-text-edit-focus'

interface FontStyleSelectProps {
  value: string
  disabled: boolean
  fontFamilyIdMixed: boolean
  variantFontIdMixed: boolean
  variantStyleNamePlaceholder: string
  /** Options for a single family: its faces. */
  sortedVariants: Font[]
  /** Options for a mixed-family selection: the style names every family shares. */
  mixedFamilyStyleItems: Array<{ styleName: string }>
  onValueChange: (value: string) => void
  onOpenChange: (open: boolean) => void
}

/** The Style select (Regular / Bold / Italic …) for the current family or families. */
export function FontStyleSelect({
  value,
  disabled,
  fontFamilyIdMixed,
  variantFontIdMixed,
  variantStyleNamePlaceholder,
  sortedVariants,
  mixedFamilyStyleItems,
  onValueChange,
  onOpenChange,
}: FontStyleSelectProps) {
  return (
    <div className="space-y-3" onPointerDown={keepTextEditFocus}>
      <label className="text-sm font-medium text-foreground leading-normal">Style</label>
      <Select
        value={value}
        onValueChange={onValueChange}
        onOpenChange={onOpenChange}
        disabled={disabled}
      >
        <SelectTrigger size="sm" className="mt-2" aria-label="Font style">
          <SelectValue
            placeholder={
              variantFontIdMixed ? 'Mixed' : variantStyleNamePlaceholder || 'Typeface style'
            }
          />
        </SelectTrigger>
        <SelectContent data-text-edit-keepalive="">
          {fontFamilyIdMixed
            ? mixedFamilyStyleItems.map((item) => (
                <SelectItem key={item.styleName} value={item.styleName} className="text-xs">
                  {item.styleName}
                </SelectItem>
              ))
            : sortedVariants.map((vf) => (
                <SelectItem key={vf.fontId} value={String(vf.fontId)} className="text-xs">
                  {vf.fontStyle?.fontStyleName ?? vf.fontName}
                </SelectItem>
              ))}
        </SelectContent>
      </Select>
    </div>
  )
}
